var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('navHeader'),_c('keep-alive',[_c('router-view')],1),_c('footer-copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }